import createDOMPurify from 'dompurify';

const PREVIEW_SANITIZE_OPTIONS = {
  FORBID_TAGS: ['script'],
  ADD_TAGS: ['iframe'],
  ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling'],
};

export type DOMPurifyWindow = Parameters<typeof createDOMPurify>[0];

export function sanitizePreviewHtml(
  html: string,
  currentWindow: DOMPurifyWindow = window as DOMPurifyWindow,
): string {
  const domPurify = createDOMPurify(currentWindow);

  return domPurify.sanitize(html, PREVIEW_SANITIZE_OPTIONS);
}

export function sanitizePreviewDocumentHtml(
  html: string,
  currentWindow: DOMPurifyWindow = window as DOMPurifyWindow,
): string {
  const domPurify = createDOMPurify(currentWindow);

  return domPurify.sanitize(html, {
    ...PREVIEW_SANITIZE_OPTIONS,
    WHOLE_DOCUMENT: true,
  });
}
